import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import { Location } from "@curai/js-fhir-tools";
import type { PharmacyType } from "../schema";

export interface PharmacySearchParams {
  name?: string;
  city?: string;
  state?: string;
  zip?: string;
  address?: string;
  phone?: string;
  serviceLevels: PharmacyType;
}

export interface PharmacySearchResponse {
  pharmacies: Location[];
}

export const usePharmacySearch = (
  params: PharmacySearchParams | null,
  { enabled }: { enabled: boolean },
) => {
  return useApi<PharmacySearchResponse, Location[]>({
    queryOptions: {
      enabled: Boolean(enabled && params),
      queryFn: async () => {
        const response = await axiosInstance.get<PharmacySearchResponse>(
          "/rx/pharmacies/search",
          { params: params },
        );

        return response.data;
      },
      queryKey: QueryKeys.Provider.Pharmacy.SEARCH(params),
      select: (data) =>
        data.pharmacies?.map((pharmacy) => new Location(pharmacy)) || [],
    },
  });
};
